import { Amplify } from 'aws-amplify';
import { config, validateConfig } from './config';

// Amplify configuration for authentication
export const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: config.cognitoUserPoolId,
            userPoolClientId: config.cognitoClientId,
        },
    },
};

/**
 * Initialize AWS Amplify with authentication configuration
 * This should be called once at application startup
 */
export function initializeAmplify(): void {
    try {
        // Validate required environment variables first
        validateConfig();

        // Configure Amplify with authentication settings
        Amplify.configure(amplifyConfig);

        console.log('AWS Amplify initialized successfully');
    } catch (error) {
        console.error('Failed to initialize AWS Amplify:', error);
        throw error;
    }
}

/**
 * Get the current Amplify configuration
 * Useful for debugging and testing
 */
export function getAmplifyConfig() {
    return amplifyConfig;
}
